/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Joseph_WatersInputs */

const en_testimonial_joseph_waters = /** @type {(inputs: Testimonial_Joseph_WatersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tried a lot of text-to-speech apps before finding listening. From the purpose of reading academic books or papers it takes the top spot. It reliable skips footnotes and other content I do not want read out, and this cannot be said for other apps. I'm impressed.`)
};

const es_testimonial_joseph_waters = /** @type {(inputs: Testimonial_Joseph_WatersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probé muchas apps de texto a voz antes de encontrar Listening. Para el propósito de leer libros o artículos académicos, ocupa el primer lugar. Omite de manera confiable las notas al pie y otro contenido que no quiero que se lea, y esto no se puede decir de otras apps. Estoy impresionado.`)
};

/**
* | output |
* | --- |
* | "I tried a lot of text-to-speech apps before finding listening. From the purpose of reading academic books or papers it takes the top spot. It reliable skips ..." |
*
* @param {Testimonial_Joseph_WatersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_joseph_waters = /** @type {((inputs?: Testimonial_Joseph_WatersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Joseph_WatersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_joseph_waters(inputs)
	return en_testimonial_joseph_waters(inputs)
});